import "./css/error.css"
import { Link } from "react-router-dom"
import Footer from "./../footer/footer"
const Error = () => {
    return (
        <>
            <div className="linkErrorMainContainer">
                <div className="linkErrorContainer">
                    <div className="linkErrorHomePageLinkContainer">
                        <Link to="/"> Go to Home page</Link>
                    </div>
                    <div className="linkErrorShowDigitContainer">
                        404
                    </div>
                    <div className="linkErrorShowTextContainer">
                        Page Not Found
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}


export default Error